import type { WorkItemResolution } from '@ayumia/contracts';
import { text } from '../app/i18n';
import './step-trail.css';

/**
 * Fil d'étapes du procédé (work-item-resolution 2.2.0, ADR-141 §1.1, §3 bis) : les étapes humaines
 * du workflow, celles faites cochées, l'étape en cours mise en avant, les suivantes numérotées et
 * estompées. Présentation seulement : le Work Engine décide de l'enchaînement. Rien hors workflow.
 */
export function StepTrail({ progress }: { progress: WorkItemResolution['progress'] }) {
  if (progress === undefined || progress.steps.length === 0) return null;
  return (
    <nav className="ay-steptrail" aria-label="Étapes du procédé">
      <ol className="ay-steptrail__list">
        {progress.steps.map((step, index) => {
          const label = text(step.label, 'fr', step.step_id);
          const state = step.status === 'done' ? 'faite' : step.status === 'current' ? 'en cours' : 'à venir';
          return (
            <li key={step.step_id} className={`ay-steptrail__step ay-steptrail__step--${step.status}`} data-status={step.status} aria-current={step.status === 'current' ? 'step' : undefined}>
              <span className="ay-steptrail__marker" aria-hidden="true">
                {step.status === 'done' ? '✓' : index + 1}
              </span>
              <span className="ay-steptrail__label">{label}</span>
              <span className="ay-visually-hidden"> ({state})</span>
            </li>
          );
        })}
      </ol>
    </nav>
  );
}
